import { FilePreviewKeySource } from './types';

export function getFileRevisionKey(file: Pick<FilePreviewKeySource, 'modifiedAt'>): string {
  return file.modifiedAt ?? '';
}

export function resolveFileIdentity(file: FilePreviewKeySource): string {
  return String(file._id || file.localId || file.title || '');
}

export function buildFilePreviewKey(
  file: FilePreviewKeySource,
  source: string | undefined,
  rightPanelVisible: boolean | undefined
): string {
  return `${resolveFileIdentity(file)},${source ?? ''},${getFileRevisionKey(file)},${rightPanelVisible}`;
}
